import React, { useEffect, useState } from "react";
import CloseIcon from "../../assets/img/common/close-gray-icon.jpg";
import { useRef } from "react";
import useOutsideClick from "../../hooks/useOutsideClick";
import { useNavigate } from "react-router-dom";

import { useChainId, useChains } from "wagmi";
import ExternalLink from "../common/ExternalLink";
import { contractNetworks } from "../../utils/currencies";
import WalletDisplay from "../common/WalletDisplay";

const SuccessFullMintedNFTPopup = ({ data, show, setShow }) => {
  // Get current chain using Wagmi v2 hooks
  const chainId = useChainId();
  const chains = useChains();
  const chain = chains?.find((c) => c.id === chainId);
  const funderAddress = data?.funder?.public_address || data?.funder;
  
  const handleClose = () => {
    setShow(false);
  };
  const modalRef = useRef(null);
  useOutsideClick(modalRef, handleClose, null, show);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);
  return (
    <div className="min-w-[100vw] w-full h-screen flex justify-center items-center bg-[#241b4795] backdrop-blur-md fixed top-0 left-0  roboto-font z-50 ">
      <div
        ref={modalRef}
        className="w-11/12 md:w-[650px] flex flex-col items-center pb-5 pt-1 rounded-3xl bg-white "
      >
        <div className="w-full flex justify-end py-3 px-5">
          <button onClick={handleClose}>
            <img src={CloseIcon} alt="CloseIcon" />
          </button>
        </div>
        <span className="text-3xl font-semibold abel-font mt-1 ">
          NFT Minted!
        </span>

        {/* /////////////// */}

        <div className="w-full  flex flex-col items-center  px-5 md:px-10">
          <div className="flex items-center mt-8 max-w-full text-lg px-1">
            <span className="min-w-fit">tx hash : </span>
            <ExternalLink
              href={`${contractNetworks?.[data?.blockchain]?.explorer}/tx/${
                data?.txHash
              }`}
              className="font-mono "
            >
              &nbsp;
              {data?.txHash}
            </ExternalLink>
          </div>
          <div className="flex items-center mt-2 max-w-full text-lg px-1 w-full">
            <span className="min-w-fit">amount : </span>
            <span className="font-mono ">
              &nbsp;
              {data?.amount}
            </span>
          </div>
          <div className="flex items-center mt-2 max-w-full text-lg px-1 w-full ">
            <span className="min-w-fit">network : </span>
            <span className="text-blue-400 font-mono truncate">
              &nbsp;
              {chain?.network}
            </span>
          </div>

          <div className="flex items-center mt-2 max-w-full text-lg px-1 w-full ">
            <span className="min-w-fit">funder address : </span>
            <ExternalLink
              href={`${
                contractNetworks?.[data?.blockchain]?.explorer
              }/address/${funderAddress}`}
              className="font-mono"
            >
              &nbsp;
              <WalletDisplay address={funderAddress} />
            </ExternalLink>
          </div>
          <a
            href={`${contractNetworks?.[data?.blockchain]?.explorer}/tx/${
              data?.txHash
            }`}
            target="_blank"
            rel="noreferrer"
            className={`w-full text-white flex justify-center items-center bg-light-primary  h-12 rounded-[10px] mt-5 `}
          >
            View On Etherscan
          </a>
        </div>
        {/* /////////////// */}
      </div>
    </div>
  );
};

export default SuccessFullMintedNFTPopup;
